/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import type {
  ApiErrorDTO,
  ApiTokenDTO,
  BadRequestResponse,
  CreateApiTokenDTO,
  DeleteSuccessDTO,
  ForbiddenResponse,
  GetApiTokenListParams,
  HasApiTokenWithActiveScopeGroupDTO,
  HasApiTokenWithActiveScopeGroupParams,
  InternalServerErrorResponse,
  PaginatedApiTokenDTOListItems,
  TooManyRequestsResponse,
  UnauthorizedResponse,
} from "../../model";
import { customFetchInstance } from "../../../custom-fetch-instance";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * Returns all Api Token in pages
 * @summary Returns a paginated List of all Api Token
 */
export type getApiTokenListResponse = {
  data: PaginatedApiTokenDTOListItems;
  status: number;
};

export const getGetApiTokenListUrl = (
  organisationId: string,
  params?: GetApiTokenListParams
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  return normalizedParams.size
    ? `http://localhost:8080/platform/v1/organisations/${organisationId}/api-tokens?${normalizedParams.toString()}`
    : `http://localhost:8080/platform/v1/organisations/${organisationId}/api-tokens`;
};

export const getApiTokenList = async (
  organisationId: string,
  params?: GetApiTokenListParams,
  options?: RequestInit
): Promise<getApiTokenListResponse> => {
  return customFetchInstance<Promise<getApiTokenListResponse>>(
    getGetApiTokenListUrl(organisationId, params),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getGetApiTokenListQueryKey = (
  organisationId: string,
  params?: GetApiTokenListParams
) => {
  return [
    `http://localhost:8080/platform/v1/organisations/${organisationId}/api-tokens`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiTokenListQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTokenList>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  organisationId: string,
  params?: GetApiTokenListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTokenList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiTokenListQueryKey(organisationId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTokenList>>> = ({
    signal,
  }) => getApiTokenList(organisationId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTokenList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiTokenListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTokenList>>
>;
export type GetApiTokenListQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | TooManyRequestsResponse
  | InternalServerErrorResponse;

export function useGetApiTokenList<
  TData = Awaited<ReturnType<typeof getApiTokenList>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  organisationId: string,
  params: undefined | GetApiTokenListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTokenList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTokenList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetApiTokenList<
  TData = Awaited<ReturnType<typeof getApiTokenList>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  organisationId: string,
  params?: GetApiTokenListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTokenList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTokenList>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetApiTokenList<
  TData = Awaited<ReturnType<typeof getApiTokenList>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  organisationId: string,
  params?: GetApiTokenListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTokenList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a paginated List of all Api Token
 */

export function useGetApiTokenList<
  TData = Awaited<ReturnType<typeof getApiTokenList>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  organisationId: string,
  params?: GetApiTokenListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTokenList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiTokenListQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetApiTokenListSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTokenList>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  organisationId: string,
  params?: GetApiTokenListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getApiTokenList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiTokenListQueryKey(organisationId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTokenList>>> = ({
    signal,
  }) => getApiTokenList(organisationId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getApiTokenList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetApiTokenListSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTokenList>>
>;
export type GetApiTokenListSuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | TooManyRequestsResponse
  | InternalServerErrorResponse;

export function useGetApiTokenListSuspense<
  TData = Awaited<ReturnType<typeof getApiTokenList>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  organisationId: string,
  params: undefined | GetApiTokenListParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getApiTokenList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetApiTokenListSuspense<
  TData = Awaited<ReturnType<typeof getApiTokenList>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  organisationId: string,
  params?: GetApiTokenListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getApiTokenList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetApiTokenListSuspense<
  TData = Awaited<ReturnType<typeof getApiTokenList>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  organisationId: string,
  params?: GetApiTokenListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getApiTokenList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a paginated List of all Api Token
 */

export function useGetApiTokenListSuspense<
  TData = Awaited<ReturnType<typeof getApiTokenList>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  organisationId: string,
  params?: GetApiTokenListParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getApiTokenList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetApiTokenListSuspenseQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a new Api Token. Only Audiologists and ERP-Supplier can create Api Tokens.
Can throw the following error codes:
`ERR_POINT_OF_SALE_ID_UNKNOWN`

Further explanation about the error codes can be found in the projects README.

 * @summary Creates a new Api Token
 */
export type createApiTokenResponse = {
  data: ApiTokenDTO;
  status: number;
};

export const getCreateApiTokenUrl = (organisationId: string) => {
  return `http://localhost:8080/platform/v1/organisations/${organisationId}/api-tokens`;
};

export const createApiToken = async (
  organisationId: string,
  createApiTokenDTO: CreateApiTokenDTO,
  options?: RequestInit
): Promise<createApiTokenResponse> => {
  return customFetchInstance<Promise<createApiTokenResponse>>(
    getCreateApiTokenUrl(organisationId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(createApiTokenDTO),
    }
  );
};

export const getCreateApiTokenMutationOptions = <
  TError =
    | ApiErrorDTO
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createApiToken>>,
    TError,
    { organisationId: string; data: CreateApiTokenDTO },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createApiToken>>,
  TError,
  { organisationId: string; data: CreateApiTokenDTO },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createApiToken>>,
    { organisationId: string; data: CreateApiTokenDTO }
  > = (props) => {
    const { organisationId, data } = props ?? {};

    return createApiToken(organisationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateApiTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof createApiToken>>
>;
export type CreateApiTokenMutationBody = CreateApiTokenDTO;
export type CreateApiTokenMutationError =
  | ApiErrorDTO
  | UnauthorizedResponse
  | ForbiddenResponse
  | TooManyRequestsResponse
  | InternalServerErrorResponse;

/**
 * @summary Creates a new Api Token
 */
export const useCreateApiToken = <
  TError =
    | ApiErrorDTO
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createApiToken>>,
    TError,
    { organisationId: string; data: CreateApiTokenDTO },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createApiToken>>,
  TError,
  { organisationId: string; data: CreateApiTokenDTO },
  TContext
> => {
  const mutationOptions = getCreateApiTokenMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Returns a boolean value if the organisation has an Api Token with the specified active scope group
 * @summary Returns a boolean value if the organisation has an Api Token with the specified active scope group
 */
export type hasApiTokenWithActiveScopeGroupResponse = {
  data: HasApiTokenWithActiveScopeGroupDTO;
  status: number;
};

export const getHasApiTokenWithActiveScopeGroupUrl = (
  organisationId: string,
  params: HasApiTokenWithActiveScopeGroupParams
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  return normalizedParams.size
    ? `http://localhost:8080/platform/v1/organisations/${organisationId}/api-tokens/scope-group?${normalizedParams.toString()}`
    : `http://localhost:8080/platform/v1/organisations/${organisationId}/api-tokens/scope-group`;
};

export const hasApiTokenWithActiveScopeGroup = async (
  organisationId: string,
  params: HasApiTokenWithActiveScopeGroupParams,
  options?: RequestInit
): Promise<hasApiTokenWithActiveScopeGroupResponse> => {
  return customFetchInstance<Promise<hasApiTokenWithActiveScopeGroupResponse>>(
    getHasApiTokenWithActiveScopeGroupUrl(organisationId, params),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getHasApiTokenWithActiveScopeGroupQueryKey = (
  organisationId: string,
  params: HasApiTokenWithActiveScopeGroupParams
) => {
  return [
    `http://localhost:8080/platform/v1/organisations/${organisationId}/api-tokens/scope-group`,
    ...(params ? [params] : []),
  ] as const;
};

export const getHasApiTokenWithActiveScopeGroupQueryOptions = <
  TData = Awaited<ReturnType<typeof hasApiTokenWithActiveScopeGroup>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  organisationId: string,
  params: HasApiTokenWithActiveScopeGroupParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hasApiTokenWithActiveScopeGroup>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getHasApiTokenWithActiveScopeGroupQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hasApiTokenWithActiveScopeGroup>>
  > = ({ signal }) =>
    hasApiTokenWithActiveScopeGroup(organisationId, params, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hasApiTokenWithActiveScopeGroup>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HasApiTokenWithActiveScopeGroupQueryResult = NonNullable<
  Awaited<ReturnType<typeof hasApiTokenWithActiveScopeGroup>>
>;
export type HasApiTokenWithActiveScopeGroupQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | TooManyRequestsResponse
  | InternalServerErrorResponse;

export function useHasApiTokenWithActiveScopeGroup<
  TData = Awaited<ReturnType<typeof hasApiTokenWithActiveScopeGroup>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  organisationId: string,
  params: HasApiTokenWithActiveScopeGroupParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hasApiTokenWithActiveScopeGroup>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hasApiTokenWithActiveScopeGroup>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHasApiTokenWithActiveScopeGroup<
  TData = Awaited<ReturnType<typeof hasApiTokenWithActiveScopeGroup>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  organisationId: string,
  params: HasApiTokenWithActiveScopeGroupParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hasApiTokenWithActiveScopeGroup>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hasApiTokenWithActiveScopeGroup>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHasApiTokenWithActiveScopeGroup<
  TData = Awaited<ReturnType<typeof hasApiTokenWithActiveScopeGroup>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  organisationId: string,
  params: HasApiTokenWithActiveScopeGroupParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hasApiTokenWithActiveScopeGroup>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a boolean value if the organisation has an Api Token with the specified active scope group
 */

export function useHasApiTokenWithActiveScopeGroup<
  TData = Awaited<ReturnType<typeof hasApiTokenWithActiveScopeGroup>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  organisationId: string,
  params: HasApiTokenWithActiveScopeGroupParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hasApiTokenWithActiveScopeGroup>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHasApiTokenWithActiveScopeGroupQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getHasApiTokenWithActiveScopeGroupSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof hasApiTokenWithActiveScopeGroup>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  organisationId: string,
  params: HasApiTokenWithActiveScopeGroupParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof hasApiTokenWithActiveScopeGroup>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getHasApiTokenWithActiveScopeGroupQueryKey(organisationId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hasApiTokenWithActiveScopeGroup>>
  > = ({ signal }) =>
    hasApiTokenWithActiveScopeGroup(organisationId, params, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!organisationId,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof hasApiTokenWithActiveScopeGroup>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HasApiTokenWithActiveScopeGroupSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof hasApiTokenWithActiveScopeGroup>>
>;
export type HasApiTokenWithActiveScopeGroupSuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | TooManyRequestsResponse
  | InternalServerErrorResponse;

export function useHasApiTokenWithActiveScopeGroupSuspense<
  TData = Awaited<ReturnType<typeof hasApiTokenWithActiveScopeGroup>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  organisationId: string,
  params: HasApiTokenWithActiveScopeGroupParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof hasApiTokenWithActiveScopeGroup>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHasApiTokenWithActiveScopeGroupSuspense<
  TData = Awaited<ReturnType<typeof hasApiTokenWithActiveScopeGroup>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  organisationId: string,
  params: HasApiTokenWithActiveScopeGroupParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof hasApiTokenWithActiveScopeGroup>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHasApiTokenWithActiveScopeGroupSuspense<
  TData = Awaited<ReturnType<typeof hasApiTokenWithActiveScopeGroup>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  organisationId: string,
  params: HasApiTokenWithActiveScopeGroupParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof hasApiTokenWithActiveScopeGroup>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a boolean value if the organisation has an Api Token with the specified active scope group
 */

export function useHasApiTokenWithActiveScopeGroupSuspense<
  TData = Awaited<ReturnType<typeof hasApiTokenWithActiveScopeGroup>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(
  organisationId: string,
  params: HasApiTokenWithActiveScopeGroupParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof hasApiTokenWithActiveScopeGroup>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHasApiTokenWithActiveScopeGroupSuspenseQueryOptions(
    organisationId,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deletes a specific Api Token by id.
 * @summary Deletes a specific Api Token.
 */
export type deleteApiTokenByIdResponse = {
  data: DeleteSuccessDTO;
  status: number;
};

export const getDeleteApiTokenByIdUrl = (
  organisationId: string,
  tokenId: string
) => {
  return `http://localhost:8080/platform/v1/organisations/${organisationId}/api-tokens/${tokenId}`;
};

export const deleteApiTokenById = async (
  organisationId: string,
  tokenId: string,
  options?: RequestInit
): Promise<deleteApiTokenByIdResponse> => {
  return customFetchInstance<Promise<deleteApiTokenByIdResponse>>(
    getDeleteApiTokenByIdUrl(organisationId, tokenId),
    {
      ...options,
      method: "DELETE",
    }
  );
};

export const getDeleteApiTokenByIdMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiTokenById>>,
    TError,
    { organisationId: string; tokenId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiTokenById>>,
  TError,
  { organisationId: string; tokenId: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiTokenById>>,
    { organisationId: string; tokenId: string }
  > = (props) => {
    const { organisationId, tokenId } = props ?? {};

    return deleteApiTokenById(organisationId, tokenId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiTokenByIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiTokenById>>
>;

export type DeleteApiTokenByIdMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | TooManyRequestsResponse
  | InternalServerErrorResponse;

/**
 * @summary Deletes a specific Api Token.
 */
export const useDeleteApiTokenById = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiTokenById>>,
    TError,
    { organisationId: string; tokenId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiTokenById>>,
  TError,
  { organisationId: string; tokenId: string },
  TContext
> => {
  const mutationOptions = getDeleteApiTokenByIdMutationOptions(options);

  return useMutation(mutationOptions);
};
